export enum ScoutRank {
    HO,
    HR
}

export enum InstructorRank {
    Pwd,
    Phm,
    Hm
}

export interface Scout {
    Id?: string;
    InstructorId: string,
    ScoutRank: ScoutRank,
    ScoutPledgeDay?: number,
    ScoutPledgeMonth?: number,
    ScoutPledgeYear?: number,
    CorporateId?: string,
    InstructorRank: InstructorRank,
    ScoutFleurDeLisId?: string,
    PwdDate: string,
    PhmDate?: string,
    HmDate?: string,
    ScoutRegionId: string
}